<template>
  <component
    :is="addToCartComponent"
    :item="item"
    :message="message"
    @product-added-to-cart="$emit('product-added-to-cart', $event)"
  />
</template>

<script>
// @flow

import { mapState } from 'vuex'

import { SHOPS } from '../../../../../../common/custom/shops'

import AddToCartButtonDefault from './custom/default/AddToCartButtonDefault.vue'
import AddToCartButtonJeanAndLen from './custom/jeanandlen/AddToCartButtonJeanAndLen.vue'

export default {
  components: {
    AddToCartButtonDefault
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState(['customerId']),
    addToCartComponent () {
      const customAddToCartComponents = {
        [SHOPS.JEAN_AND_LEN_CUSTOMER_ID]: AddToCartButtonJeanAndLen,
        [SHOPS.JEAN_AND_LEN_EN_CUSTOMER_ID]: AddToCartButtonJeanAndLen,
        [SHOPS.JEAN_AND_LEN_TESTING_CUSTOMER_ID]: AddToCartButtonJeanAndLen,
        [SHOPS.JEAN_AND_LEN_TEMP_CUSTOMER_ID]: AddToCartButtonJeanAndLen
      }

      return customAddToCartComponents[this.customerId] || AddToCartButtonDefault
    }
  }
}
</script>

<style src="./add-to-cart-button.scss" />
